module.exports = __webpack_public_path__ + "static/media/arrow-ios-back-outline.77e998a0.svg";